import gql from 'graphql-tag'
// this is like VimeoVodeUserVideosInfo but just enough to see if we already know it
// id = user id, vimeoID = user as known by vimeo, limit how many to get
export default gql`
    query VimeoUserVideosTiny ($id: ID!, $vimeoID: ID, $limit: Int, $offset: Int, $value: Value) {
      VimeoUserVideosTiny (id: $id, vimeoID: $vimeoID, limit: $limit, offset: $offset, value: $value) {
        limit
        offset
        totalItems
        VimeoVideoTinies {
          id
          uri
          name
          FilmMastersFromVimeoID {
            id
          }
        }
      }
    }
  `
